/**
 * Habilita todos as flags experimentais
 */
export const EXPERIMENTAL = process.env.REACT_APP_EXPERIMENTAL

/**
 * Especifica se as telas novas de atendimento devem ser mostradas
 */

export const ATENDIMENTO_NOVO_ENABLED = process.env.REACT_APP_ATENDIMENTO_NOVO_ENABLED ?? EXPERIMENTAL

export const ATENDIMENTO_ODONTOLOGICO_ENABLED = process.env.REACT_APP_ATENDIMENTO_ODONTOLOGICO_ENABLED ?? EXPERIMENTAL

export const ATENDIMENTO_VACINACAO_ENABLED = process.env.REACT_APP_ATENDIMENTO_VACINACAO_ENABLED ?? EXPERIMENTAL

export const RELATORIOS_BI_ATENDIMENTO_ENABLED = process.env.REACT_APP_RELATORIOS_BI_ATENDIMENTO_ENABLED ?? EXPERIMENTAL

export const UNIFICACAO_BASE_ENABLED = process.env.REACT_APP_UNIFICACAO_BASE_ENABLED ?? EXPERIMENTAL

export const UNIFICACAO_BASE_TEST_ENABLED = process.env.REACT_APP_UNIFICACAO_BASE_TEST_ENABLED ?? EXPERIMENTAL
